const footerColumns = [
  {
    title: "内容导航",
    links: [
      { label: "证据汇总", href: "#archive" },
      { label: "时间线核对", href: "#timeline" },
      { label: "来源说明", href: "#source" },
      { label: "常见问题", href: "#faq" },
    ],
  },
  {
    title: "证据类型",
    links: [
      { label: "聊天截图", href: "#archive" },
      { label: "同框照", href: "#archive" },
      { label: "定位信息", href: "#archive" },
      { label: "时间戳画面", href: "#archive" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-xl font-bold text-primary-800">
                黑
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black tracking-wide text-background-50">
                  黑料照片
                </span>
                <span className="mt-1 font-label text-[10px] uppercase tracking-[0.22em] text-background-100/60">
                  Evidence Archive
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-7 text-background-100/80">
              整理带实锤性质的证据型照片：聊天截图、同框照、定位信息与时间戳画面，
              每张图标注来源与关联事件，方便对照时间线判断可信度。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["来源标注", "时间戳核对", "定位交叉"].map((tag) => (
                <span
                  key={tag}
                  className="whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-[11px] text-background-50"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer whitespace-nowrap text-sm text-background-100/75 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">核对提示</h4>
            <p className="mt-4 text-sm leading-7 text-background-100/80">
              画面内容仅供对照参考，请以来源原图为准。遇到存疑素材，先看来源，再对时间戳，
              最后用定位交叉印证。
            </p>
            <a
              href="#top"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-background-50/10"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-up-line text-sm" />
              </span>
              回到顶部
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 黑料照片 · 证据型照片资料库</p>
          <p className="hidden sm:block">仅作素材归档与对照参考，请勿用于不当用途。</p>
        </div>
      </div>
    </footer>
  );
}